const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaTipo: [],
	listaGrupo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PREMIO_FAIXA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PREMIO_FAIXA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'PREMIO_FAIXA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        case 'PREMIO_FAIXA_GRUPO_SELECT_LISTADO':
			return {
				...state,
				listaGrupo: action.payload.data
			};

        default:
            return state;
    }
}
